import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { FileUploadModule } from 'primeng/fileupload';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { TextareaModule } from 'primeng/textarea';
import { EditorModule } from 'primeng/editor';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { UserService } from '../../layout/service/user.service';

@Component({
    selector: 'app-create-anatomi',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        FileUploadModule,
        CardModule,
        DividerModule,
        ToastModule,
        EditorModule,
        ToggleSwitchModule
    ],
    providers: [MessageService],
    template: `
        <div class="min-h-screen bg-gray-50 p-4">
            <div class="max-w-7xl mx-auto">
                <div class="bg-white rounded-lg shadow-sm border border-gray-200">
                    <!-- Header -->
                    <div class="flex justify-between items-center p-6 border-b border-gray-200">
                        <div>
                            <h2 class="text-2xl font-bold text-gray-900 flex items-center">
                                <i class="pi pi-plus-circle mr-2 text-blue-600"></i>
                                Tambah Anatomi Baru
                            </h2>
                            <p class="text-gray-600 mt-2">Buat konten anatomi untuk pembelajaran OSCE</p>
                        </div>
                        <p-button
                            (onClick)="clearAll()"
                            severity="danger"
                            icon="pi pi-trash"
                            label="Clear Semua"
                            [outlined]="true"
                        ></p-button>
                    </div>

                    <!-- Form Content -->
                    <div class="p-6">
                        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
                            <!-- Main Form -->
                            <div class="lg:col-span-2">
                                <div class="bg-white border border-gray-200 rounded-lg p-6">
                                    <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                                        <i class="pi pi-info-circle mr-2 text-blue-600"></i>
                                        Informasi Anatomi
                                    </h3>

                                    <!-- Nama Anatomi -->
                                    <div class="mb-6">
                                        <label class="block text-sm font-medium text-gray-700 mb-2">
                                            Nama Anatomi <span class="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            [(ngModel)]="anatomyForm.nama"
                                            placeholder="Masukkan nama anatomi..."
                                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                                    </div>

                                    <!-- Deskripsi -->
                                    <div class="mb-6">
                                        <label class="block text-sm font-medium text-gray-700 mb-2">
                                            Deskripsi <span class="text-red-500">*</span>
                                        </label>
                                        <textarea
                                            [(ngModel)]="anatomyForm.deskripsi"
                                            rows="4"
                                            placeholder="Masukkan deskripsi anatomi..."
                                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none">
                                        </textarea>
                                    </div>

                                    <!-- Status Aktif -->
                                    <div class="mb-6">
                                        <div class="flex items-center justify-between">
                                            <label class="block text-sm font-medium text-gray-700">
                                                Status Anatomi
                                            </label>
                                            <div class="flex items-center space-x-3">
                                                <span class="text-sm text-gray-600">{{anatomyForm.isActive ? 'Aktif' : 'Tidak Aktif'}}</span>
                                                <p-toggleswitch [(ngModel)]="anatomyForm.isActive"></p-toggleswitch>
                                            </div>
                                        </div>
                                        <small class="text-gray-500 mt-1 block">Aktifkan untuk menampilkan anatomi ini kepada pengguna</small>
                                    </div>

                                    <hr class="my-6 border-gray-200">

                                    <!-- Konten Anatomi -->
                                    <div class="mb-6">
                                        <div class="flex justify-between items-center mb-4">
                                            <label class="block text-sm font-medium text-gray-700 flex items-center">
                                                <i class="pi pi-list mr-2 text-blue-600"></i>
                                                Konten Pembelajaran
                                            </label>
                                            <p-button
                                                type="button"
                                                (onClick)="addContent()"
                                                severity="info"
                                                size="small"
                                                icon="pi pi-plus"
                                                label="Tambah Konten"
                                            ></p-button>
                                        </div>

                                        <div *ngFor="let content of anatomyForm.contents; let i = index"
                                             id="content-{{i}}"
                                             class="border border-gray-200 rounded-lg p-4 mb-4 bg-gray-50 transition-all duration-300">
                                            <div class="flex justify-between items-center mb-3">
                                                <span class="text-sm font-medium text-gray-600">Konten {{i + 1}}</span>
                                                <p-button
                                                    type="button"
                                                    (onClick)="removeContent(i)"
                                                    severity="danger"
                                                    size="small"
                                                    icon="pi pi-trash"
                                                    [text]="true"
                                                ></p-button>
                                            </div>

                                            <!-- Upload Gambar -->
                                            <div class="mb-4">
                                                <label class="block text-sm font-medium text-gray-700 mb-2">
                                                    <i class="pi pi-image mr-1"></i>
                                                    Gambar Konten
                                                </label>
                                                <div class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-400 transition-colors cursor-pointer">
                                                    <input type="file" accept="image/*" (change)="onImageUpload($event, i)" class="hidden" #imageInput>
                                                    <div (click)="imageInput.click()">
                                                        <i class="pi pi-cloud-upload text-2xl text-gray-400 mb-2 block"></i>
                                                        <p class="text-sm text-gray-600 mb-1">
                                                            {{content.imageName || 'Klik untuk upload gambar'}}
                                                        </p>
                                                        <small class="text-gray-500">Max: 5MB (JPG, PNG, GIF)</small>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Editor Konten -->
                                            <div class="mb-4">
                                                <label class="block text-sm font-medium text-gray-700 mb-2">
                                                    <i class="pi pi-file-edit mr-1"></i>
                                                    Konten Pembelajaran
                                                </label>
                                                <p-editor
                                                    [(ngModel)]="content.content"
                                                    [style]="{'height':'200px'}"
                                                    placeholder="Tulis konten pembelajaran di sini...">
                                                </p-editor>
                                            </div>

                                            <!-- Kunci Jawaban -->
                                            <div class="mb-4">
                                                <label class="block text-sm font-medium text-gray-700 mb-2">
                                                    <i class="pi pi-key mr-1"></i>
                                                    Kunci Jawaban
                                                </label>
                                                <input
                                                    type="text"
                                                    [(ngModel)]="content.answerKey"
                                                    placeholder="Masukkan kunci jawaban..."
                                                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                                            </div>

                                            <!-- Upload PDF -->
                                            <div class="mb-4">
                                                <label class="block text-sm font-medium text-gray-700 mb-2">
                                                    <i class="pi pi-file-pdf mr-1"></i>
                                                    File PDF Pendukung
                                                </label>
                                                <div class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-blue-400 transition-colors cursor-pointer">
                                                    <input type="file" accept=".pdf" (change)="onPdfUpload($event, i)" class="hidden" #pdfInput>
                                                    <div (click)="pdfInput.click()">
                                                        <i class="pi pi-file-pdf text-2xl text-red-500 mb-2 block"></i>
                                                        <p class="text-sm text-gray-600 mb-1">
                                                            {{content.pdfName || 'Klik untuk upload PDF'}}
                                                        </p>
                                                        <small class="text-gray-500">Max: 10MB (PDF)</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="anatomyForm.contents.length === 0"
                                             class="text-center p-8 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50">
                                            <i class="pi pi-inbox text-4xl text-gray-400 mb-3 block"></i>
                                            <p class="text-gray-600 mb-1">Belum ada konten pembelajaran</p>
                                            <small class="text-gray-500">Klik "Tambah Konten" untuk menambah materi</small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Sidebar -->
                            <div class="lg:col-span-1">
                                <div class="bg-white border border-gray-200 rounded-lg p-6 h-fit">
                                    <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                                        <i class="pi pi-info-circle mr-2 text-blue-600"></i>
                                        Informasi Tambahan
                                    </h3>

                                    <!-- Preview Status -->
                                    <div class="mb-6 p-4 bg-blue-50 rounded-lg">
                                        <div class="flex items-center justify-between">
                                            <span class="text-sm font-medium text-blue-800">Status:</span>
                                            <span class="px-2 py-1 text-xs rounded-full {{anatomyForm.isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}}">
                                                {{anatomyForm.isActive ? 'Aktif' : 'Tidak Aktif'}}
                                            </span>
                                        </div>
                                        <div class="mt-2">
                                            <span class="text-sm text-blue-600">Total Konten: {{anatomyForm.contents.length}}</span>
                                        </div>
                                    </div>

                                    <!-- Panduan -->
                                    <div class="mb-6">
                                        <h4 class="text-sm font-semibold text-gray-800 mb-2">Panduan Pengisian:</h4>
                                        <ul class="text-xs text-gray-600 space-y-1">
                                            <li class="flex items-start">
                                                <i class="pi pi-check-circle text-green-500 mr-2 mt-0.5"></i>
                                                Isi nama dan deskripsi anatomi
                                            </li>
                                            <li class="flex items-start">
                                                <i class="pi pi-check-circle text-green-500 mr-2 mt-0.5"></i>
                                                Aktifkan status untuk publikasi
                                            </li>
                                            <li class="flex items-start">
                                                <i class="pi pi-check-circle text-green-500 mr-2 mt-0.5"></i>
                                                Tambahkan konten dengan gambar
                                            </li>
                                            <li class="flex items-start">
                                                <i class="pi pi-check-circle text-green-500 mr-2 mt-0.5"></i>
                                                Gunakan editor untuk konten rich text
                                            </li>
                                            <li class="flex items-start">
                                                <i class="pi pi-check-circle text-green-500 mr-2 mt-0.5"></i>
                                                Sertakan kunci jawaban
                                            </li>
                                            <li class="flex items-start">
                                                <i class="pi pi-check-circle text-green-500 mr-2 mt-0.5"></i>
                                                Upload PDF sebagai referensi
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <!-- Daftar Pertanyaan Card -->
                                <div class="bg-white border border-gray-200 rounded-lg p-6 h-fit mt-6">
                                    <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                                        <i class="pi pi-list-check mr-2 text-blue-600"></i>
                                        Daftar Pertanyaan
                                    </h3>

                                    <div *ngIf="anatomyForm.contents.length === 0" class="text-center py-8">
                                        <i class="pi pi-inbox text-3xl text-gray-400 mb-2 block"></i>
                                        <p class="text-sm text-gray-500">Belum ada pertanyaan</p>
                                        <small class="text-gray-400">Tambahkan konten untuk melihat daftar pertanyaan</small>
                                    </div>

                                    <div *ngIf="anatomyForm.contents.length > 0" class="space-y-3">
                                        <div *ngFor="let content of anatomyForm.contents; let i = index"
                                             class="border border-gray-200 rounded-lg p-3 hover:bg-gray-50 cursor-pointer transition-colors"
                                             (click)="scrollToContent(i)">
                                            <div class="flex items-start space-x-3">
                                                <div class="flex-shrink-0">
                                                    <span class="inline-flex items-center justify-center w-6 h-6 bg-blue-100 text-blue-600 rounded-full text-xs font-medium">
                                                        {{i + 1}}
                                                    </span>
                                                </div>
                                                <div class="flex-1 min-w-0">
                                                    <p class="text-sm font-medium text-gray-800 mb-1">
                                                        Pertanyaan {{i + 1}}
                                                    </p>
                                                    <p class="text-xs text-gray-600 line-clamp-2">
                                                        {{getContentPreview(content)}}
                                                    </p>
                                                    <div class="mt-2 flex items-center space-x-2">
                                                        <span class="inline-flex items-center text-xs text-gray-500">
                                                            <i class="pi pi-image mr-1" [class.text-green-500]="content.imageName" [class.text-gray-400]="!content.imageName"></i>
                                                            {{content.imageName ? 'Ada gambar' : 'Tanpa gambar'}}
                                                        </span>
                                                        <span class="inline-flex items-center text-xs text-gray-500">
                                                            <i class="pi pi-file-pdf mr-1" [class.text-red-500]="content.pdfName" [class.text-gray-400]="!content.pdfName"></i>
                                                            {{content.pdfName ? 'Ada PDF' : 'Tanpa PDF'}}
                                                        </span>
                                                    </div>
                                                    <div class="mt-1" *ngIf="content.answerKey">
                                                        <span class="inline-flex items-center text-xs text-green-600 bg-green-50 px-2 py-1 rounded">
                                                            <i class="pi pi-key mr-1"></i>
                                                            {{content.answerKey.length > 20 ? content.answerKey.substring(0, 20) + '...' : content.answerKey}}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="flex-shrink-0">
                                                    <i class="pi pi-chevron-right text-gray-400"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="flex justify-end gap-3 mt-6 pt-6 border-t border-gray-200">
                            <p-button
                                type="button"
                                (onClick)="saveDraft()"
                                [disabled]="isLoading"
                                [loading]="isLoading"
                                severity="secondary"
                                icon="pi pi-save"
                                label="Draft"
                                [loadingIcon]="isLoading ? 'pi pi-spinner pi-spin' : ''"
                            ></p-button>
                            <p-button
                                type="button"
                                (onClick)="saveAndPublish()"
                                [disabled]="isLoading"
                                [loading]="isLoading"
                                severity="success"
                                icon="pi pi-check"
                                label="Simpan & Publikasi"
                                [loadingIcon]="isLoading ? 'pi pi-spinner pi-spin' : ''"
                            ></p-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p-toast></p-toast>
    `
})
export class CreateAnatomi implements OnInit{
    anatomyForm = {
        nama: '',
        deskripsi: '',
        isActive: false,
        contents: [] as any[]
    };

    isLoading = false;

    categories = [
        { name: 'Sistem Muskuloskeletal', code: 'muskuloskeletal' },
        { name: 'Sistem Kardiovaskular', code: 'kardiovaskular' },
        { name: 'Sistem Respirasi', code: 'respirasi' },
        { name: 'Sistem Pencernaan', code: 'pencernaan' },
        { name: 'Sistem Saraf', code: 'saraf' },
        { name: 'Sistem Endokrin', code: 'endokrin' },
        { name: 'Sistem Reproduksi', code: 'reproduksi' },
        { name: 'Sistem Urinaria', code: 'urinaria' }
    ];

    difficultyLevels = [
        { name: 'Pemula', code: 'beginner' },
        { name: 'Menengah', code: 'intermediate' },
        { name: 'Lanjutan', code: 'advanced' },
        { name: 'Expert', code: 'expert' }
    ];

    statusOptions = [
        { name: 'Draft', code: 'draft' },
        { name: 'Aktif', code: 'active' },
        { name: 'Nonaktif', code: 'inactive' }
    ];

    contentTypes = [
        { name: 'Teori', code: 'theory' },
        { name: 'Praktik', code: 'practice' },
        { name: 'Latihan', code: 'exercise' },
        { name: 'Kasus', code: 'case' },
        { name: 'Tips', code: 'tips' }
    ];

    constructor(
        private messageService: MessageService,
        private userService: UserService
    ) {}

    ngOnInit(): void {

    }

    saveAnatomy() {
        if (!this.validateForm()) {
            return;
        }

        this.isLoading = true;

        // Convert form data to required JSON format
        this.convertToJsonFormat().then((jsonData) => {
            this.userService.addAnatomy(jsonData).then(() => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: 'Anatomi berhasil disimpan'
                });
                // Reset form
                this.resetForm();
            }).catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Anatomi gagal disimpan'
                });
            }).finally(() => {
                this.isLoading = false;
            });
        }).catch((error) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error saat memproses file'
            });
            this.isLoading = false;
        });
    }

    private async convertToJsonFormat(): Promise<any> {
        const details = await Promise.all(
            this.anatomyForm.contents.map(async (content) => {
                let imageBase64 = '';
                let pdfBase64 = '';

                // Convert image to base64
                if (content.imageFile) {
                    imageBase64 = await this.fileToBase64(content.imageFile);
                }

                // Convert PDF to base64
                if (content.pdfFile) {
                    pdfBase64 = await this.fileToBase64(content.pdfFile);
                }

                return {
                    question: content.content || '', // Using editor content as question
                    image: imageBase64,
                    explanation: pdfBase64,
                    key_answer: content.answerKey || ''
                };
            })
        );

        return {
            name: this.anatomyForm.nama,
            description: this.anatomyForm.deskripsi,
            draft: "0", // Always 0 as per your format
            is_active: this.anatomyForm.isActive ? 1 : 0,
            details: details
        };
    }

    private fileToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const result = reader.result as string;
                // Remove data:type/subtype;base64, prefix
                const base64 = result.split(',')[1];
                resolve(base64);
            };
            reader.onerror = error => reject(error);
        });
    }

    scrollToContent(index: number) {
        const element = document.getElementById(`content-${index}`);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
            // Add highlight effect
            element.classList.add('ring-2', 'ring-blue-400', 'ring-opacity-50');
            setTimeout(() => {
                element.classList.remove('ring-2', 'ring-blue-400', 'ring-opacity-50');
            }, 2000);
        }
    }

    getContentPreview(content: any): string {
        if (!content.content) return 'Konten kosong';
        // Remove HTML tags and get first 50 characters
        const text = content.content.replace(/<[^>]*>/g, '');
        return text.length > 50 ? text.substring(0, 50) + '...' : text;
    }

    private resetForm() {
        this.anatomyForm = {
            nama: '',
            deskripsi: '',
            isActive: false,
            contents: []
        };
    }

    goBack() {
        window.history.back();
    }

    clearAll() {
        if (this.anatomyForm.nama || this.anatomyForm.deskripsi || this.anatomyForm.contents.length > 0) {
            // Show confirmation dialog
            if (confirm('Apakah Anda yakin ingin menghapus semua data yang telah diisi? Tindakan ini tidak dapat dibatalkan.')) {
                this.resetForm();
                this.messageService.add({
                    severity: 'info',
                    summary: 'Form Dikosongkan',
                    detail: 'Semua data telah dihapus dari form'
                });
            }
        } else {
            this.messageService.add({
                severity: 'warn',
                summary: 'Form Kosong',
                detail: 'Form sudah dalam keadaan kosong'
            });
        }
    }

    addContent() {
        this.anatomyForm.contents.push({
            content: '',
            answerKey: '',
            imageName: '',
            imageFile: null,
            pdfName: '',
            pdfFile: null
        });
    }

    removeContent(index: number) {
        this.anatomyForm.contents.splice(index, 1);
    }

    onImageUpload(event: any, index: number) {
        const file = event.target.files[0];
        if (file) {
            this.anatomyForm.contents[index].imageFile = file;
            this.anatomyForm.contents[index].imageName = file.name;
        }
    }

    onPdfUpload(event: any, index: number) {
        const file = event.target.files[0];
        if (file) {
            this.anatomyForm.contents[index].pdfFile = file;
            this.anatomyForm.contents[index].pdfName = file.name;
        }
    }

    saveDraft() {
        if (!this.validateForm()) {
            return;
        }

        // Save as draft with is_active = 0
        this.anatomyForm.isActive = false;
        this.saveAnatomy();
    }

    saveAndPublish() {
        if (!this.validateForm()) {
            return;
        }

        // Save and publish with is_active = 1
        this.anatomyForm.isActive = true;
        this.saveAnatomy();
    }

    private validateForm(): boolean {
        if (!this.anatomyForm.nama.trim()) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Nama anatomi harus diisi'
            });
            return false;
        }

        if (!this.anatomyForm.deskripsi.trim()) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Deskripsi harus diisi'
            });
            return false;
        }

        if (this.anatomyForm.contents.length === 0) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Minimal harus ada satu konten pembelajaran'
            });
            return false;
        }

        // Validate each content
        for (let i = 0; i < this.anatomyForm.contents.length; i++) {
            const content = this.anatomyForm.contents[i];

            if (!content.content || content.content.trim() === '') {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: `Konten pembelajaran ${i + 1} harus diisi`
                });
                return false;
            }

            if (!content.answerKey || content.answerKey.trim() === '') {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: `Kunci jawaban untuk konten ${i + 1} harus diisi`
                });
                return false;
            }
        }

        return true;
    }
}